import React, {useEffect, useRef, useState} from 'react';
import {Box, IconButton} from '@mui/material';
import './RecentHistory.scss';
import ArrMenu, {
  ArrMenuHandle,
  CustomMenuItem,
} from '../../../../common/arr-menu/ArrMenu';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../../redux/store';

import {ReactComponent as HistoryIcon} from '../../../../../assets/images/history-icon.svg';
import {setActiveDocument} from '../../../docViewerUtils';

interface RecentHistoryProps {
  onSelectDocument?: (customMenuItem: CustomMenuItem) => void;
  panelId?: string;
}

const RecentHistory: React.FC<RecentHistoryProps> = ({
  onSelectDocument,
  panelId,
}) => {
  const activeDoc = useSelector((state: RootState) => state.docView.activeDoc);
  const historyList = useSelector(
    (state: RootState) => state.docView.documentHistory
  );
  const menuRef = useRef<ArrMenuHandle>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [menuItems, setMenuItems] = useState<CustomMenuItem[]>([]);

  useEffect(() => {
    const items: CustomMenuItem[] = historyList.map((item) => ({
      id: item.docId,
      label: item.docId,
      selected: item.docId == activeDoc?.docId,
    }));
    setMenuItems(items);
  }, [activeDoc, historyList]);

  const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    menuRef.current?.open(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelectDocument = (item: CustomMenuItem) => {
    const history = historyList.find((doc) => doc.docId === item.id) ?? null;
    if (!history) return;
    setActiveDocument(history);
    onSelectDocument?.(item);
  };

  return (
    <Box className="recent-history">
      <IconButton
        size="small"
        className="recent-history-button"
        aria-label="remove"
        onClick={handleButtonClick}
        aria-expanded={Boolean(anchorEl)}
        data-tab-id="mini-doc-list-recent-history"
        data-tab-group={panelId}
        role="button"
        data-testid="recent-history-remove"
      >
        <HistoryIcon />
      </IconButton>
      <ArrMenu
        ref={menuRef}
        id="recent-history-menu"
        items={menuItems}
        onClose={handleMenuClose}
        direction="bottom-right"
        className="recent-history-menu"
        onItemClick={handleSelectDocument}
      />
    </Box>
  );
};

export default RecentHistory;
